import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

import { ButtonDirective } from '../../../ui/button/button/button.directive';
import { IconButtonDirective } from '../../../ui/button/icon-button/icon-button.directive';

export interface NotificationData {
  action?: string;
  message: string;
  closable: boolean;
}

@Component({
  selector: 'semeris-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, IconButtonDirective, MatIcon],
})
export class NotificationComponent implements OnInit {
  snackbarRef = inject<MatSnackBarRef<NotificationComponent>>(MatSnackBarRef);
  readonly data = inject<NotificationData>(MAT_SNACK_BAR_DATA);

  public ngOnInit(): void {}

  public onDismiss(action?: string) {
    if (action) {
      this.snackbarRef.dismissWithAction();
    } else {
      this.snackbarRef.dismiss();
    }
  }
}
